import { setCookie, getCookie } from '../../../utils/cookies.js';

const cookieName = 'site__preloader';

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

document.addEventListener('DOMContentLoaded', () => {
  const preloader = document.querySelector('.preloader');
  if (!preloader) {
    return;
  }

  if (getCookie(cookieName)) {
    preloader.remove();

    return;
  }

  if (window.scrollY !== 0) {
    window.scrollTo(0, 0);
  }

  const startTime = performance.now();
  const duration = 8000;
  const timer = (currentTime) => {
    if (currentTime - startTime >= duration) {
      preloader.classList.add('is-done');
      setCookie(cookieName, 'done');
    } else {
      requestAnimationFrame(timer);
    }
  };
  requestAnimationFrame(timer);
});
